/* Auto Generated */

export enum GetMicrosoftSubscriptionsFilterDTO {
    all = 0,
    active = 1,
    inactive = 2,
    purchasable = 3,
    notPurchasable = 4,
}
